import ErrorBoundary from 'components/ErrorBoundary';
import MainLayout from 'layouts/MainLayout/MainLayout';
import NotFoundPage from 'modules/Miscellaneous/NotFoundPage';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { privateRoutes, publicRoutes } from 'routes/constants';
import { TRoute } from './types';

const renderNestedRoutes = (routes: TRoute[], parentPath?: string) =>
  routes.map(route => {
    if (route.index) {
      return (
        <Route
          key={`${parentPath}-index`}
          index
          element={route.element}
          handle={route.handle}
          errorElement={<ErrorBoundary />}
        />
      );
    }

    return (
      <Route
        key={route.path}
        path={route.path}
        element={route.element}
        handle={route.handle}
        errorElement={<ErrorBoundary />}
      >
        {route.children &&
          renderNestedRoutes(
            route.children,
            `${parentPath}/${route.path ?? ''}`
          )}
      </Route>
    );
  });

const AppRouterConfig = createBrowserRouter(
  createRoutesFromElements(
    <>
      {publicRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
          errorElement={<ErrorBoundary />}
        />
      ))}

      <Route element={<MainLayout />}>
        {renderNestedRoutes(privateRoutes)}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </>
  )
);

export default AppRouterConfig;
